import { QuizState } from "@/interfaces/sdk-quiz";
import { quizAttachmentTypes, quizPatterns, quizzes } from "./types";

export default {
  [quizzes]: (state: QuizState) => state.quizzes,
  [quizPatterns]: (state: QuizState) => state.patterns,
  [quizAttachmentTypes]: (state: QuizState) => state.attachmentTypes,
};
